var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03991 14.7225C1.36621 15.0329 1.81984 15.2 2.30531 15.2C2.38693 15.2 2.46528 15.1935 2.54665 15.1867C2.59222 15.1829 2.63875 15.179 2.68732 15.1761L5.24996 14.7384C5.73543 14.6588 6.3562 14.3246 6.69046 13.9665L13.2244 7.0505C14.8559 5.3235 14.8082 3.62037 13.0812 1.98888C11.3542 0.35738 9.65103 0.405131 8.01953 2.13213L1.48558 9.04809C1.14337 9.39826 0.848902 10.0429 0.793192 10.5284L0.498727 13.1069C0.4271 13.7436 0.626063 14.3325 1.03991 14.7225ZM8.88701 2.93594C9.42819 2.36293 9.96141 1.98092 10.5742 1.98092C11.0676 1.98092 11.6168 2.23559 12.2535 2.8484C13.694 4.20135 13.3358 5.17229 12.349 6.22281L11.4693 7.1539C9.75586 6.86303 8.39007 5.5591 8.01412 3.86093L8.88701 2.93594ZM7.06342 4.86837L2.35306 9.85985C2.19389 10.027 2.01085 10.4249 1.97901 10.6557L1.68455 13.2343C1.65271 13.4969 1.71638 13.7118 1.85963 13.8471C2.00289 13.9824 2.21777 14.0301 2.4804 13.9903L5.04304 13.5526C5.27384 13.5128 5.65585 13.3059 5.81502 13.1388L10.527 8.15125C8.9313 7.64679 7.65189 6.43553 7.06342 4.86837Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.43a914d769b36c601f96841bb7c227de.svg";
export { ForwardRef as ReactComponent };